/**
 * Storage Constants
 * Storage key management and configuration
 * @module @infra/storage
 */

/**
 * Storage prefix for all keys
 */
export const STORAGE_PREFIX = 'tma_sale_agents' as const;

/**
 * Storage version (for future migrations)
 */
export const STORAGE_VERSION = '1' as const;

/**
 * Storage scope (global or tenant-specific)
 */
export const STORAGE_SCOPE = 'global' as const;

/**
 * localStorage key for sidebar toggle state
 */
export const SIDEBAR_STATE_KEY = 'sidebar_state' as const;

/**
 * localStorage key for authentication state
 */
export const AUTH_STATE_KEY = 'auth_state' as const;

/**
 * localStorage key for auth tokens
 */
export const AUTH_TOKEN_KEY = 'token' as const;
